exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".shrink img{max-height:11rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-90ad3c2a","scoped":false,"hasInlineConfig":false}!/~/vue-loader/lib/selector.js?type=styles&index=0!./assets/js/vue/components/SlimUploader.vue
// module id = 396
// module chunks = 0